import { FCX } from "@datassential/platform-ui-lib";
import { HOME_PEOPLE_DISPLAY_METRICS_ORDER, Metric } from "@models/Metric";
import { Dispatch, SetStateAction, useCallback, useMemo } from "react";
import { Select } from "@components/Select";
import { useMetric, useMetrics } from "@core/CommonDataContext";
import { IOption } from "@models";

const SelectDisplayMetric: FCX<{
    value: Metric | null;
    setValue: Dispatch<SetStateAction<Metric | null>>;
    hideBase?: boolean;
    hidePolarity?: boolean;
    onChange?: () => void;
}> = ({
    value: rawValue,
    setValue: rawSetValue,
    hideBase = false,
    hidePolarity = false,
    onChange,
}) => {
    const rawOptions = useMetrics(HOME_PEOPLE_DISPLAY_METRICS_ORDER);
    const polarityMetric = useMetric(Metric.PolarityScore);

    const options = useMemo(
        (): IOption<Metric | null>[] => [
            ...rawOptions.map(i => ({
                id: i.id as Metric | null,
                title: i.name ?? '',
            })),
            ...(hideBase ? [] : [{ id: null, title: 'Base' }]),
            ...(hidePolarity || !polarityMetric ? [] : [{ id: polarityMetric.id, title: polarityMetric.name }]),
        ],
        [rawOptions, hideBase, hidePolarity, polarityMetric]
    );

    const value = useMemo(
        (): Array<Metric | null> => [rawValue],
        [rawValue]
    );

    const setValue = useCallback(
        (newValue: Array<Metric | null>) => {
            rawSetValue(newValue[0] ?? null);
            onChange?.();
        },
        [rawSetValue, onChange]
    );

    return (
        <Select
            label="DISPLAY:"
            options={options}
            value={value}
            setValue={setValue}
        />
    );
}

export default SelectDisplayMetric;